import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { GlobalDataStorage } from '../share/storages/global-data.storage';
import { catchError } from 'rxjs/operators';

@Injectable(

)
export class LocaleInterceptor implements HttpInterceptor {
    constructor(
        private globalDataStorage: GlobalDataStorage
    ) {}

    isShowTokenExpired = false;

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                locale: this.globalDataStorage.getStorage('locale') || 'en'
            }
        });
        return next.handle(request).pipe(
            catchError((error: any) => {
                return throwError(error);
            })
        );
    }
}
